import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const DISMISS_KEY = "urban_welcome_dismissed";
const KNOWN_KEY = "urban_known_user";

export const WelcomeBanner = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return !!(localStorage.getItem(DISMISS_KEY) || localStorage.getItem(KNOWN_KEY));
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (user) {
      try { localStorage.setItem(KNOWN_KEY, "1"); } catch { /* ignore */ }
      setDismissed(true);
    }
  }, [user]);

  const hiddenPath = location.pathname.startsWith("/jewelry") || location.pathname.startsWith("/checkout");
  if (loading || user || dismissed || hiddenPath) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div data-testid="welcome-banner" className="relative z-50 bg-[#1C1917] text-white">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm">
        <Sparkles className="w-4 h-4 text-amber-400 shrink-0" />
        <p className="leading-snug">
          <span className="font-semibold">New here?</span> Get{" "}
          <span className="text-amber-400 font-bold">$10 off</span> your first order of $30+ with code{" "}
          <span data-testid="welcome-banner-code" className="font-mono font-bold bg-amber-400 text-[#1C1917] px-1.5 py-0.5 rounded">URBANWELCOME</span>
        </p>
        <Link
          to="/store/restaurant"
          data-testid="welcome-banner-order-link"
          className="hidden sm:inline-block shrink-0 font-semibold underline underline-offset-2 text-amber-300 hover:text-amber-200"
        >
          Order now
        </Link>
        <button
          onClick={dismiss}
          data-testid="welcome-banner-dismiss"
          aria-label="Dismiss welcome offer"
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded hover:bg-white/10 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
